import { render, staticRenderFns } from "./Tcu.vue?vue&type=template&id=51c50192&lang=html&"
import script from "./Tcu.vue?vue&type=script&lang=js&"
export * from "./Tcu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports